import { render, staticRenderFns } from "./createHelp.vue?vue&type=template&id=d60dbbca"
import script from "./createHelp.vue?vue&type=script&lang=js"
export * from "./createHelp.vue?vue&type=script&lang=js"
import style0 from "./createHelp.vue?vue&type=style&index=0&id=d60dbbca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports